<template>
    <div class="mains">
        <div class="container">
            <div class="top_box">
                <div class="left_box">
                    <div class="saoma" :class="{ 'active1': active == '1' }" @click="openBase"><span>基础信息</span> </div>
                    <div class="hotMap" :class="{ 'active': active == '2' }" @click="openAnimal">
                        <span>牧业信息</span>
                    </div>
                </div>
                <i @click="close" class="el-icon-close"></i>
            </div>
            <div class="line_box base_list" v-show="baseShow">
                <div class="left">
                    <div class="top">
                        <div class="quan">
                            <div class="cattle_">
                                <span></span>
                                <span>户主信息</span>
                            </div>
                        </div>
                        <div class="info">

                            <div class="img_box">
                                <img :src="`${houseHolderList.avatar}`" alt="">
                            </div>
                            <!-- ../../../assets/people.png -->
                            <div class="info_flex" style="margin-top: .2rem;">
                                <div class="info_t">
                                    <div>
                                        <span>姓名：</span>
                                        <span>{{ houseHolderList.nickName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="info_flex">
                                <div class="info_t">
                                    <div>
                                        <span>性别：</span>
                                        <span>{{ houseHolderList.sex }}</span>
                                    </div>
                                    <div>
                                        <span>出生年月：</span>
                                        <span>{{ houseHolderList.birthday }}</span>
                                    </div>
                                    <div>
                                        <span>联系电话：</span>
                                        <span>{{ houseHolderList.phonenumber }}</span>
                                    </div>
                                </div>
                                <div class="info_t">
                                    <div>
                                        <span>民族：</span>
                                        <span>{{ houseHolderList.nation }}</span>
                                    </div>
                                    <div>
                                        <span>年龄：</span>
                                        <span>{{
                                            (getAgeByDateOfBirth(houseHolderList.birthday) == '0' ? '1' :
                                                getAgeByDateOfBirth(houseHolderList.birthday)) || '—'
                                        }}</span>
                                    </div>
                                    <div>
                                        <span>籍贯：</span>
                                        <span>{{ houseHolderList.nativePlaceName }}</span>
                                    </div>
                                </div>
                                <div class="info_t" style="flex: 1.2;">
                                    <div>
                                        <span>身份证号：</span>
                                        <span>{{ houseHolderList.corprateIdNo }}</span>
                                    </div>
                                    <div>
                                        <span>学历：</span>
                                        <span>{{ houseHolderList.education }}</span>
                                    </div>
                                    <div>
                                        <span>政治面貌：</span>
                                        <span>{{ houseHolderList.politicalFace }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="info_flex">
                                <div class="info_t">
                                    <div>
                                        <span>家庭住址：</span>
                                        <span>{{ houseHolderList.homeAddressInfo }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="info_flex">
                                <div class="info_t">
                                    <div>
                                        <span>家庭结构：</span>
                                        <span>{{ houseHolderList.remark }}</span>
                                        <!-- <span>—</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="bottom">
                        <div class="quan">
                            <div class="cattle_">
                                <span></span>
                                <span>家庭成员</span>
                            </div>
                        </div>
                        <div class="family">
                            <div class="info_flex" style="padding-top: .1rem;">
                                <div class="info_t">
                                    <div>
                                        <span>姓名：</span>
                                        <span>{{ familyInfo.memName || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>政治面貌：</span>
                                        <span>—</span>
                                    </div>
                                    <div>
                                        <span>学历：</span>
                                        <span>{{ familyInfo.memEducation || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>与户主关系：</span>
                                        <span>{{ familyInfo.memRelations || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>是否“两委”成员：</span>
                                        <span>{{ familyInfo.memIsCommittees || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>其他：</span>
                                        <span>{{ familyInfo.remark || '—' }}</span>
                                    </div>
                                </div>
                                <div class="info_t" style="flex:1.3">
                                    <div>
                                        <span>民族：</span>
                                        <span>{{ familyInfo.memNation || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>出生年月：</span>
                                        <span>{{ familyInfo.memBirthday || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>联系电话：</span>
                                        <span>{{ familyInfo.memPhone || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>股份证号：</span>
                                        <span>{{ familyInfo.memStockCode || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>职务：</span>
                                        <span>{{ familyInfo.memPost || '—' }}</span>
                                    </div>
                                </div>
                                <div class="info_t" style="flex:1.3">
                                    <div>
                                        <span>性别：</span>
                                        <span>{{ familyInfo.memSex || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>年龄：</span>
                                        <span>{{
                                            (getAgeByDateOfBirth(familyInfo.memBirthday) == '0' ? '1' :
                                                getAgeByDateOfBirth(familyInfo.memBirthday)) || '—'
                                        }}</span>
                                    </div>
                                    <div>
                                        <span>身份证号：</span>
                                        <span>—</span>
                                    </div>
                                    <div>
                                        <span>股份：</span>
                                        <!-- <span>{{ familyInfo.shareTotalAmount || '—' }}</span> -->
                                        <span>—</span>
                                    </div>
                                    <div>
                                        <span>工作单位：</span>
                                        <span>{{ familyInfo.memWork || '—' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="switchImg">
                            <span v-for="(item, i) in familyList" :key="i"
                                :style="{ color: familyActive == i + 1 ? '#FFFFFF' : '', border: familyActive == i + 1 ? '1px solid #FFFFFF' : '' }"
                                @click="familyBtn(i + 1)">{{ i + 1 }}</span>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="quan">
                        <div class="cattle_">
                            <span></span>
                            <span>人居环境情况</span>
                        </div>
                    </div>
                    <div class="box">
                        <div class="img">
                            <img :src="vibeImg" alt="">
                            <div class="switchImg">
                                <span v-for="(item, i) in vibeImgList" :key="i"
                                    :style="{ color: vibeActive == i + 1 ? '#FFFFFF' : '', border: vibeActive == i + 1 ? '1px solid #FFFFFF' : '' }"
                                    @click="vibeBtn(i + 1)">{{ i + 1 }}</span>
                            </div>
                            <div class="info_flex" style="margin-top: .44rem;margin-left: 0;">
                                <div class="info_t">
                                    <div>
                                        <span>住房面积：</span>
                                        <span>{{ environmentInfo.houseArea || '—' }}m²</span>
                                    </div>
                                    <div>
                                        <span>蒙古包面积：</span>
                                        <span>{{ environmentInfo.gerArea || '—' }}m²</span>
                                    </div>
                                </div>
                                <div class="info_t">
                                    <div>
                                        <span>住房坐标：</span>
                                        <span>{{ environmentInfo.houseLocation || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>蒙古包坐标：</span>
                                        <span>{{ environmentInfo.gerLocation || '—' }}</span>
                                    </div>
                                </div>
                                <div class="info_t">
                                    <div>
                                        <span>住房结构：</span>
                                        <span>{{ environmentInfo.houseStructure || '—' }}</span>
                                    </div>
                                    <div>
                                        <span>蒙古包顶：</span>
                                        <span>{{ environmentInfo.gerDing || '—' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="line_box animal_list" v-show="animalShow">
                <div class="left">
                    <div class="quan">
                        <div class="cattle_">
                            <span></span>
                            <span>草场信息</span>
                        </div>
                    </div>
                    <div class="top">
                        <div class="line_info">
                            <div class="line">
                                <div class="info">
                                    <img src="../../../assets/yq/light1.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.grasslandNo || '—' }}</span>
                                        <span>草场证号</span>
                                    </div>
                                </div>
                                <div class="info">
                                    <img src="../../../assets/yq/light3.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.contract || '—' }}</span>
                                        <span>人均承包(㎡)</span>
                                    </div>
                                </div>
                                <div class="info">
                                    <img src="../../../assets/yq/light2.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.cultivated || '—' }}</span>
                                        <span>耕地(㎡)</span>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="info">
                                    <img src="../../../assets/yq/light2.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.grasslandArea || '—' }}</span>
                                        <span>承包草场面积(㎡)</span>
                                    </div>
                                </div>
                                <div class="info">
                                    <img src="../../../assets/yq/light1.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.grazingArea || '—' }}</span>
                                        <span>禁牧区(㎡)</span>
                                    </div>
                                </div>
                                <div class="info">
                                    <img src="../../../assets/yq/light3.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.rental || '—' }}</span>
                                        <span>租赁草场(㎡)</span>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="info">
                                    <img src="../../../assets/yq/light3.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.grasslandBalance || '—' }}</span>
                                        <span>草畜平衡(㎡)</span>
                                    </div>
                                </div>
                                <div class="info">
                                    <img src="../../../assets/yq/light4.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.acquisition || '—' }}</span>
                                        <span>征地面积(㎡)</span>
                                    </div>
                                </div>
                                <div class="info">
                                    <img src="../../../assets/yq/light1.png" alt="">
                                    <div class="text">
                                        <span>{{ pastureUseMessage.hireGrassland || '—' }}</span>
                                        <span>出租草场(㎡)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="quan" style="margin-top: .28rem;">
                        <div class="cattle_">
                            <span></span>
                            <span>牧业照片</span>
                        </div>
                    </div>
                    <div class="animal_img">
                        <div class="animal_item">
                            <span class="image">草场照片</span>
                            <img :src="grasslandUrls" alt="">
                            <div class="switchImg">
                                <span v-for="(item, i) in grasslandImageUrls" :key="i"
                                    :style="{ color: grassActive == i + 1 ? '#FFFFFF' : '', border: grassActive == i + 1 ? '1px solid #FFFFFF' : '' }"
                                    @click="grassBtn(i + 1)">{{ i + 1 }}</span>
                            </div>
                        </div>
                        <div class="animal_item" style="margin-left: .65rem;">
                            <span class="image">棚圈照片</span>
                            <img :src="coveredUrls" alt="">
                            <div class="switchImg">
                                <span v-for="(item, i) in coveredImageUrls" :key="i"
                                    :style="{ color: shedActive == i + 1 ? '#FFFFFF' : '', border: shedActive == i + 1 ? '1px solid #FFFFFF' : '' }"
                                    @click="shedBtn(i + 1)">{{ i + 1 }}</span>
                            </div>
                        </div>
                        <div class="animal_item" style="margin-left: .65rem;">
                            <span class="image">设施照片</span>
                            <img :src="machineryUrls" alt="">
                            <div class="switchImg">
                                <span v-for="(item, i) in machineryImageUrls" :key="i"
                                    :style="{ color: planActive == i + 1 ? '#FFFFFF' : '', border: planActive == i + 1 ? '1px solid #FFFFFF' : '' }"
                                    @click="planBtn(i + 1)">{{ i + 1 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="quan">
                        <div class="cattle_">
                            <span></span>
                            <span>总收支情况</span>
                        </div>
                    </div>
                    <div class="top">
                        <div class="money">
                            <div>
                                <span class="hand">总收入(万元)</span>
                                <ul>
                                    <li v-for="(item, i) in totalIncome" :class="{ round: item == '.' }" :key="i">{{ item }}
                                    </li>
                                </ul>
                            </div>
                            <div style="margin-left: 1.5rem;">
                                <span class="hand">总支出(万元)</span>
                                <ul>
                                    <li v-for="(item, i) in totalExpenditure" :class="{ round: item == '.' }" :key="i">{{
                                        item }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="b_l">
                                <div class="source">收入来源</div>
                                <div class="source_list">
                                    <div class="source_col">
                                        <div class="source_item">
                                            <div>
                                                <span class="small_round"></span>
                                                <span>牛群收入</span>
                                            </div>
                                            <div>
                                                {{ incomeExpendMessage.cattleTotalAmount }}
                                                <span>万元</span>
                                            </div>
                                        </div>
                                        <div class="source_item">
                                            <div>
                                                <span class="small_round" style="background-color: #39AD36;"></span>
                                                <span>山羊收入</span>
                                            </div>
                                            <div>
                                                {{ incomeExpendMessage.goatAmount }}
                                                <span>万元</span>
                                            </div>
                                        </div>
                                        <div class="source_item">
                                            <div>
                                                <span class="small_round" style="background-color: #F7BA1E;"></span>
                                                <span>其他收入</span>
                                            </div>
                                            <div>
                                                {{ incomeExpendMessage.camelOther }}
                                                <span>万元</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="source_col" style="margin-left: .5rem;">
                                        <div class="source_item">
                                            <div>
                                                <span class="small_round" style="background-color: #5D2CFE;"></span>
                                                <span>马群收入</span>
                                            </div>
                                            <div>
                                                {{ incomeExpendMessage.horsesAmount }}
                                                <span>万元</span>
                                            </div>
                                        </div>
                                        <div class="source_item">
                                            <div>
                                                <span class="small_round" style="background-color: #2C76FE;"></span>
                                                <span>绵羊收入</span>
                                            </div>
                                            <div>
                                                {{ incomeExpendMessage.sheepAmount }}
                                                <span>万元</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="b_r">
                                <div class="source">收入情况</div>
                                <div class="money_box">
                                    <div class="money_item">生产支出：<span> {{ totalProduce }}</span>万元</div>
                                    <div class="box_1" style="margin-top: .1rem;">
                                        <div class="info_flex">
                                            <div class="info_t">
                                                <div>
                                                    <span>燃料支出: </span>
                                                    <span> {{ incomeExpendMessage.fuelAmount }}万元</span>
                                                </div>
                                                <div>
                                                    <span>工程建设支出:</span>
                                                    <span> {{ incomeExpendMessage.engineeringAmount }}万元 </span>
                                                </div>
                                                <div>
                                                    <span>其他支出:</span>
                                                    <span> {{ incomeExpendMessage.otherAmount }}万元</span>
                                                </div>
                                            </div>
                                            <div class="info_t">
                                                <div>
                                                    <span>饲草料支出:</span>
                                                    <span> {{ incomeExpendMessage.forageAmount }}万元</span>
                                                </div>
                                                <div>
                                                    <span>机械购置支出:</span>
                                                    <span> {{ incomeExpendMessage.machineryAmount }}万元</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="money_item">生活支出：<span> {{ totalLife }}</span>万元</div>
                                    <div class="box_1" style="margin-top: .1rem;">
                                        <div class="info_flex">
                                            <div class="info_t">
                                                <div>
                                                    <span>就医支出：</span>
                                                    <span>{{ incomeExpendMessage.medicalAmount }}万元</span>
                                                </div>
                                                <div>
                                                    <span>就学支出: </span>
                                                    <span>{{ incomeExpendMessage.educationAmount }}万元</span>
                                                </div>
                                                <div>
                                                    <span>生活物资支出:</span>
                                                    <span>{{ incomeExpendMessage.lifeAmount }}万元</span>
                                                </div>
                                            </div>
                                            <div class="info_t">
                                                <div>
                                                    <span>劳务支出: </span>
                                                    <span>{{ incomeExpendMessage.laborAmount }}万元</span>
                                                </div>
                                                <div>
                                                    <span> 租赁支出: </span>
                                                    <span>{{ incomeExpendMessage.leaseAmount }}万元</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="quan" style="margin-top: .28rem;">
                        <div class="cattle_">
                            <span></span>
                            <span>活畜信息</span>
                        </div>
                    </div>
                    <div class="pie_box">
                        <div class="chart">
                            <div id="pieInitChart"></div>
                        </div>
                        <div class="info_flex" style="flex: 1;">
                            <div class="info_t" style="justify-content: space-evenly;">
                                <div>
                                    <span>牛：{{ livestockUseMessage.cattleNum || 0 }}头</span>
                                    <!-- <span>喂喂喂</span> -->
                                </div>
                                <div>
                                    <span>马：{{ livestockUseMessage.horseNum || 0 }}匹</span>

                                </div>
                                <div>
                                    <span>羊：{{ livestockUseMessage.smallLivestock || 0 }}只</span>

                                </div>
                            </div>
                            <div class="info_t" style="justify-content: space-evenly;">
                                <div>
                                    <span>母畜：{{ livestockUseMessage.cattleFemaleNum || 0 }}头</span>

                                </div>
                                <div>
                                    <span>母畜：{{ livestockUseMessage.horseFemaleNum || 0 }}匹</span>
                                </div>
                                <div>
                                    <span>母畜：{{ livestockUseMessage.sheepFemaleNum || 0 }}只</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {

    },
    props: {
        openInfo: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            active: '1',
            baseShow: false,
            animalShow: false,
            totalIncome: [],//总收入
            totalExpenditure: [],//总支出
            chart: null,
            piedata: [
                { value: 0, name: '大畜', color: '#3491FA' },
                { value: 0, name: '小畜', color: '#722ED1' },
            ],
            familyActive: 1,//家庭成员切换
            vibeActive: 1,//人居环境切换
            grassActive: 1,//草场图片切换
            shedActive: 1,//棚圈图片切换
            planActive: 1,//设施图片切换
            vibeImgList: [
                { img: 'https://xmb.obs.cn-north-4.myhuaweicloud.com/dev/2023/07/zj1690790300036.jpg' },
            ],
            coveredImageUrls: [
                { img: 'https://xmb.obs.cn-north-4.myhuaweicloud.com/dev/2023/07/zj1690790300036.jpg' },
            ],//存储棚圈照片
            coveredUrls: '',//棚圈照片
            machineryImageUrls: [
                { img: 'https://xmb.obs.cn-north-4.myhuaweicloud.com/dev/2023/07/zj1690790300036.jpg' },
            ],//存储机械照片
            machineryUrls: '',//机械设施照片
            grasslandImageUrls: [
                { img: 'https://xmb.obs.cn-north-4.myhuaweicloud.com/dev/2023/07/zj1690790300036.jpg' },
            ],//草场照片
            grasslandUrls: '',//草场照片
            houseStructure: [
                { label: '砖瓦', value: '1' },
                { label: '土木', value: '2' },
                { label: '彩钢', value: '3' },
                { label: '轻钢', value: '4' },
            ],
            vibeImg: '',
            familyList: [],//存储家庭成员列表
            familyInfo: {},//存储单个家庭成员信息
            environmentInfo: {},//环境信息
            list: [1, 2, 3],
            houseHolderList: {},//户主信息
            pastureUseMessage: {},//草场信息
            incomeExpendMessage: {},//收支信息
            livestockUseMessage: {},//活畜信息
            totalLife: 0,//生活支出
            totalProduce: 0,//生产支出
        };
    },
    watch: {

    },
    created() {

    },
    mounted() {
        this.baseShow = true
        this.getList()
    },

    methods: {
        getList() {
            this.$http({
                url: `screenapp-service/aershan/v2/queryFarmerInfo/${this.openInfo.farmerId}`,
                //请求方式
                method: 'get',
                //传递的参数
                // data: {

                // },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.houseHolderList = data.result.userAsFamilyModel.sysUser
                    this.familyList = data.result.userAsFamilyModel.familyList
                    // 户主信息
                    for (var key in this.houseHolderList) {
                        if (key == 'sex') {
                            this.houseHolderList[key] = this.houseHolderList[key] == '0' ? "男" : this.houseHolderList[key] == '1' ? "女" : "未知"
                        }
                        if (key == 'avatar' && !this.houseHolderList[key]) {
                            this.houseHolderList[key] = require('../../../assets/people.png')//默认头像
                        }
                        if (key == 'corprateIdNo' && this.houseHolderList[key]) {

                            const reg = /^(.{6})(?:\d+)(.{4})$/    // 匹配身份证号前6位和后4位的正则表达式
                            const maskedIdCard = this.houseHolderList[key].replace(reg, '\$1******\$2')   // 身份证号脱敏，将中间8位替换为“*”

                            this.houseHolderList[key] = maskedIdCard
                        }
                        if (key == 'phonenumber') {
                            var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
                            if (this.houseHolderList[key] && myreg.test(this.houseHolderList[key])) {
                                this.houseHolderList[key] = this.houseHolderList[key].replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");//手机号脱敏
                            }
                        }


                        if (!this.houseHolderList[key]) {
                            this.houseHolderList[key] = '—'
                        }
                    }

                    // 家庭成员
                    if (this.familyList.length > 0) {

                        this.familyList.forEach((item) => {
                            item.memSex = item.memSex == '0' ? "男" : item.memSex == '1' ? "女" : "未知"

                            if (item.memPhone) {
                                item.memPhone = item.memPhone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
                            }

                        })
                        this.familyInfo = this.familyList[0]
                    }

                    if (data.result.baseHerdsmanMessage) {
                        if (data.result.baseHerdsmanMessage.pastureUseMessage) {
                            this.pastureUseMessage = JSON.parse(data.result.baseHerdsmanMessage.pastureUseMessage)

                            if (this.pastureUseMessage.grasslandImageUrls && !Array.isArray(this.pastureUseMessage.grasslandImageUrls)) {
                                this.grasslandImageUrls = []//草场图片

                                const arrImg = this.pastureUseMessage.grasslandImageUrls.split(',')
                                arrImg.forEach((item) => {
                                    this.grasslandImageUrls.push({ img: item })
                                })
                            }
                            this.$nextTick(() => {
                                this.grasslandUrls = this.grasslandImageUrls[0].img
                            })

                            for (var key in this.pastureUseMessage) {
                                if (!this.pastureUseMessage[key]) {
                                    this.pastureUseMessage[key] = '—'
                                }
                            }
                        } else {
                            this.$nextTick(() => {
                                this.grasslandUrls = this.grasslandImageUrls[0].img
                            })
                        }
                        this.environmentInfo = data.result.baseHerdsmanMessage
                        if (this.environmentInfo.environmentPicture && !Array.isArray(this.environmentInfo.environmentPicture)) {//人居环境
                            this.vibeImgList = []
                            const arrImg = this.environmentInfo.environmentPicture.split(',')
                            arrImg.forEach((item) => {
                                this.vibeImgList.push({ img: item })
                            })
                            this.$nextTick(() => {
                                this.vibeImg = this.vibeImgList[0].img
                            })
                        } else {
                            this.$nextTick(() => {
                                this.vibeImg = this.vibeImgList[0].img
                            })
                        }
                        this.houseStructure.forEach((item) => {
                            if (item.value == this.environmentInfo.houseStructure) {
                                this.environmentInfo.houseStructure = item.label
                            }
                        })
                        if (data.result.baseHerdsmanMessage.incomeExpendMessage) {
                            this.incomeExpendMessage = JSON.parse(data.result.baseHerdsmanMessage.incomeExpendMessage)

                            for (var key in this.incomeExpendMessage) {

                                if (!this.incomeExpendMessage[key]) {
                                    this.incomeExpendMessage[key] = '0'
                                }
                            }


                            this.totalIncome = this.incomeExpendMessage.totalIncome.split('')
                            this.totalExpenditure = this.incomeExpendMessage.totalExpenditure.split('')

                            // 计算总生产支出和生活支出
                            this.count()
                        }
                        if (data.result.baseHerdsmanMessage.livestockUseMessage) {
                            this.livestockUseMessage = JSON.parse(data.result.baseHerdsmanMessage.livestockUseMessage)
                            if (this.livestockUseMessage.coveredImageUrls && !Array.isArray(this.livestockUseMessage.coveredImageUrls)) {//棚圈照片
                                this.coveredImageUrls = []
                                const arrImg = this.livestockUseMessage.coveredImageUrls.split(',')
                                arrImg.forEach((item) => {
                                    this.coveredImageUrls.push({ img: item })
                                })
                                this.$nextTick(() => {
                                    this.coveredUrls = this.coveredImageUrls[0].img
                                })
                            } else {
                                this.$nextTick(() => {
                                    this.coveredUrls = this.coveredImageUrls[0].img
                                })
                            }
                            if (this.livestockUseMessage.machineryImageUrls && !Array.isArray(this.livestockUseMessage.machineryImageUrls)) {//机械设施照片
                                this.machineryImageUrls = []
                                const arrImg = this.livestockUseMessage.machineryImageUrls.split(',')
                                arrImg.forEach((item) => {
                                    this.machineryImageUrls.push({ img: item })
                                })
                                this.$nextTick(() => {
                                    this.machineryUrls = this.machineryImageUrls[0].img
                                })
                            } else {
                                this.$nextTick(() => {
                                    this.machineryUrls = this.machineryImageUrls[0].img
                                })
                            }

                            for (var key in this.livestockUseMessage) {

                                if (!this.livestockUseMessage[key]) {
                                    this.livestockUseMessage[key] = '—'
                                }
                            }

                            this.piedata[0].value = Number(this.livestockUseMessage.bigLivestockNum) || 0
                            this.piedata[1].value = Number(this.livestockUseMessage.smallLivestock) || 0
                        } else {
                            this.$nextTick(() => {
                                this.machineryUrls = this.machineryImageUrls[0].img
                                this.coveredUrls = this.coveredImageUrls[0].img
                            })

                        }


                    } else {
                        this.vibeImg = this.vibeImgList[0].img
                        this.machineryUrls = this.machineryImageUrls[0].img
                        this.coveredUrls = this.coveredImageUrls[0].img
                        this.grasslandUrls = this.grasslandImageUrls[0].img
                    }



                } else {
                    // this.$message.error(data.message);
                }
            })
        },
        getAgeByDateOfBirth(dateOfBirth) {
            let currentDate = new Date();
            let birthDate = new Date(dateOfBirth);
            let age = currentDate.getFullYear() - birthDate.getFullYear();
            let monthDiff = currentDate.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
                age--;
            }

            return age;
        },
        count() {
            this.totalLife = Number(this.incomeExpendMessage.lifeAmount) + Number(this.incomeExpendMessage.leaseAmount) +
                Number(this.incomeExpendMessage.laborAmount) + Number(this.incomeExpendMessage.educationAmount)
                + Number(this.incomeExpendMessage.medicalAmount)
            this.totalProduce = Number(this.incomeExpendMessage.machineryAmount) + Number(this.incomeExpendMessage.forageAmount) +
                Number(this.incomeExpendMessage.otherAmount) + Number(this.incomeExpendMessage.engineeringAmount) +
                Number(this.incomeExpendMessage.fuelAmount)
        },
        familyBtn(val) {
            this.familyActive = val
            this.familyInfo = this.familyList[val - 1]
        },
        vibeBtn(val) {
            this.vibeActive = val
            this.vibeImg = this.vibeImgList[val - 1].img
        },
        grassBtn(val) {
            this.grassActive = val
            this.grasslandUrls = this.grasslandImageUrls[val - 1].img
        },
        shedBtn(val) {
            this.shedActive = val
            this.coveredUrls = this.coveredImageUrls[val - 1].img

        },
        planBtn(val) {
            this.planActive = val
            this.machineryUrls = this.machineryImageUrls[val - 1].img
        },
        openBase() {
            this.active = '1'
            this.baseShow = true
            this.animalShow = false
        },
        openAnimal() {
            this.active = '2'
            this.animalShow = true
            this.baseShow = false
            this.$nextTick(() => {
                this.pieInitChart({
                    dom: 'pieInitChart',
                    color: ['#3491FA', '#722ED1', '#F7BA1E', '#14C9C9', '#165DFF'],
                    data: this.piedata
                })
            })
        },
        // 自定义饼图图例
        getFormatter(name, data) {
            // console.log(data);
            let arr = []
            let count, number
            let sum = 0
            data.forEach((item) => {
                sum += item.value
                return sum
            })
            for (const item of data) {
                if (item.name == name) {
                    count = `${(item.value / sum * 100).toFixed(2)}%`
                    number = item.value
                }
            }
            if (sum == 0) {
                count = `0%`
            }
            arr = [name, number, count]
            return arr.join('  ')
        },
        pieInitChart(data) {
            const dataTotal = data.data[0].value + data.data[1].value
            this.chart = this.$echarts.init(document.getElementById(data.dom))

            this.chart.clear();
            this.chart.setOption({
                title: {
                    text: `  ${dataTotal}\n\n活畜总数`,
                    x: '41%',
                    y: '25%',
                    textStyle: {
                        color: '#fff',
                        fontSize: 14
                    }
                },
                legend: {
                    show: true,
                    bottom: '-2%',
                    icon: 'circle',
                    // x: 'left',
                    // y: ' center',
                    itemWidth: 10,
                    itemHeight: 10,
                    padding: [0, 0, 20, 40],
                    textStyle: {
                        color: '#00FEFF',
                    },
                    formatter: (name) => {
                        return this.getFormatter(name, data.data)
                    },
                },
                grid: {
                    left: '10%',
                    right: '10%',
                },
                color: data.color, // 饼图各块颜色
                toolbox: {
                    show: false,
                },
                series: [
                    {
                        type: 'pie',
                        radius: [50, 80],
                        center: ['50%', '36%'],
                        roseType: data.roseType,
                        itemStyle: {
                            borderRadius: 0,
                        },
                        emphasis: {
                            label: {
                                show: false,
                                formatter: data.roseType ? '{a|{c}}\n{b|{b}} ' : '{b|{b}}\n{a|{d}%} ',
                                rich: {
                                    a: {
                                        fontSize: 20,
                                        lineHeight: 36,
                                        color: "#fff",
                                        fontWeight: 'bold'
                                    },
                                    b: {
                                        fontSize: 12,
                                        lineHeight: 24,
                                        color: "#fff"
                                    }
                                }
                            }
                        },
                        label: {
                            show: false,
                            position: "center",
                            color: "rgba(13, 17, 29,1)",
                            fontSize: 14,
                            formatter: '{a|{b}}\n{b|{c}} ',
                            rich: {
                                a: {
                                    fontSize: 20,
                                    lineHeight: 36,
                                    color: "#fff"
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 24,
                                    color: "#fff"
                                }
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data.data,
                    }
                ],
            })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        close() {
            this.$emit('closeInfo')
        },

    },
};
</script>
<style lang="scss" scoped>
.mains {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.74);
    opacity: 1;
    z-index: 9999;

    .container {
        position: relative;
        background-image: url('../../../assets/yq/info-bg.png');
        background-size: 100% 100%;
        width: 20.25rem;
        height: 11.19rem;

        .top_box {
            width: 100%;
            height: .56rem;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left_box {
                position: relative;
                display: flex;
                cursor: pointer;
                background-color: #041a1e;
                // margin-bottom: 0.025rem;

                &::after {
                    position: absolute;
                    // left: 4.35rem;
                    left: 4.58rem;
                    top: 0;
                    content: "";
                    display: block;
                    // border: .28rem solid transparent;
                    // border-right: 0.28rem solid #000000;
                    // border-top: 0.28rem solid #000000;
                    border-width: 0.28rem 0.16rem;
                    border-style: solid;
                    border-color: #000000 #000000 transparent transparent;
                }

                .saoma {
                    width: 2.44rem;
                    height: 0.56rem;
                    color: #3dbab0;
                    font-size: 0.23rem;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    text-align: center;
                    line-height: .56rem;
                    border-radius: 10px 0 0 0;

                    span {
                        margin-right: .3rem;
                    }

                    &::after {
                        position: absolute;
                        left: 2.15rem;
                        top: 0;
                        content: "";
                        display: block;
                        /* border: 0.28rem solid transparent; */
                        /* border-right: 0.28rem solid #041a1e; */
                        /* border-top: 0.28rem solid #041a1e; */
                        border-width: 0.3rem 0.16rem;
                        border-style: solid;
                        border-color: #041a1d #041a1d transparent transparent;
                    }
                }



                .hotMap {
                    width: 2.44rem;
                    height: 0.56rem;
                    color: #3dbab0;
                    font-size: 0.23rem;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    text-align: center;
                    line-height: .56rem;

                    span {
                        margin-left: -0.5rem;
                    }
                }
            }

            .el-icon-close {
                width: 0.25rem;
                height: 0.25rem;
                color: #00E0DB;
                font-size: .25rem;
                cursor: pointer;
            }
        }



        .line_box {
            position: relative;
            // margin-top: .85rem;
            height: 10.63rem;
            width: 20.25rem;
            padding: .36rem .34rem .32rem .38rem;
            display: flex;
            margin-top: .56rem;
        }

        .base_list {


            .left {
                flex: 1;

                .top {
                    .img_box1 {}

                    .info {
                        width: 9.5rem;
                        height: 4.88rem;
                        background: rgba(0, 223, 218, 0.04);
                        border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                        opacity: 1;
                        margin-top: .4rem;
                        display: flex;
                        flex-direction: column;
                        // align-items: center;
                        padding-right: .2rem;



                        .img_box {
                            width: 1.25rem;
                            height: 1.25rem;
                            opacity: 1;
                            // border: 0.04rem solid #FFFFFF;
                            border-radius: 50%;
                            margin-left: .29rem;
                            margin-top: .3rem;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 50%;

                            }
                        }


                    }

                }

                .bottom {
                    margin-top: .28rem;

                    .family {
                        margin-top: .4rem;
                        width: 9.5rem;
                        height: 3.13rem;
                        background: rgba(0, 223, 218, 0.04);
                        border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                        opacity: 1;
                    }
                }
            }

            .right {
                flex: 1;
                margin-left: .5rem;

                .box {
                    width: 9.5rem;
                    height: 8.88rem;
                    background: rgba(0, 223, 218, 0.04);
                    border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                    opacity: 1;
                    margin-top: .4rem;

                    .img {
                        padding: .25rem;

                        img {
                            display: block;
                            width: 9rem;
                            height: 6.25rem;
                            border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                            opacity: 1;
                        }


                    }
                }
            }
        }

        .animal_list {
            display: flex;

            .left {
                flex: 1;

                .top {
                    width: 9.5rem;
                    height: 4.63rem;
                    background: rgba(0, 223, 218, 0.04);
                    border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                    opacity: 1;
                    margin-top: .4rem;
                }

                .animal_img {
                    display: flex;
                    margin-top: .4rem;
                    width: 9.5rem;
                    height: 3.81rem;
                    background: rgba(0, 223, 218, 0.04);
                    border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                    opacity: 1;
                    padding: .16rem .5rem .23rem .21rem;

                    .animal_item {
                        flex: 1;

                        .image {
                            ont-size: 0.18rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                        }

                        img {
                            display: block;
                            width: 2.5rem;
                            height: 2.5rem;
                            border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                            opacity: 1;
                            margin-top: .16rem;
                        }
                    }
                }
            }

            .right {
                flex: 1;
                margin-left: .5rem;

                .top {
                    margin-top: .4rem;
                    width: 9.5rem;
                    height: 4.63rem;
                    background: rgba(0, 223, 218, 0.04);
                    border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                    opacity: 1;
                    padding: .16rem .26rem .26rem .21rem;

                    .money {
                        display: flex;

                        div {
                            display: flex;
                            flex-direction: column;

                            .hand {
                                font-size: 0.18rem;
                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                font-weight: 400;
                                color: #FFFFFF;
                            }

                            ul {
                                margin-top: .19rem;
                                // margin-left: .25rem;
                                display: flex;

                                li {
                                    width: 0.45rem;
                                    height: 0.5rem;
                                    background: rgba(0, 224, 219, 0.05);
                                    box-shadow: inset 0rem 0rem 0.08rem 0rem rgba(0, 224, 219, 0.2);
                                    border-radius: 0rem 0rem 0rem 0rem;
                                    opacity: 1;
                                    border: 0.01rem solid rgba(0, 224, 219, 0.1);
                                    font-size: 0.33rem;
                                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                                    font-weight: 700;
                                    color: #00E0DB;
                                    line-height: 0.5rem;
                                    text-align: center;
                                    margin-right: .14rem;
                                }
                            }
                        }
                    }

                    .bottom {
                        display: flex;
                        margin-top: .2rem;

                        .source {
                            font-size: 0.18rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                        }

                        .b_l {


                            .source_list {
                                display: flex;
                                // margin-top: .36rem;

                                .source_col {
                                    display: flex;
                                    flex-direction: column;

                                    .source_item {
                                        display: flex;
                                        flex-direction: column;
                                        margin-top: .39rem;

                                        div:nth-child(1) {
                                            display: flex;
                                            align-items: center;

                                            span:nth-child(2) {
                                                margin-left: .1rem;
                                                font-size: 0.15rem;
                                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                                font-weight: 400;
                                                color: #9AA7B3;
                                            }

                                            .small_round {
                                                width: 0.08rem;
                                                height: 0.08rem;
                                                background: #00E0DB;
                                                border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                                                opacity: 1;
                                            }
                                        }

                                        div:nth-child(2) {
                                            margin-top: .15rem;
                                            font-size: 0.2rem;
                                            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                                            font-weight: 500;
                                            color: #00FEFF;
                                            padding-left: .15rem;

                                            span {
                                                ont-size: 0.15rem;
                                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                                font-weight: 400;
                                                color: #9AA7B3;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .b_r {
                            margin-left: 1.6rem;

                            .money_box {
                                .money_item {
                                    font-size: 0.15rem;
                                    font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                                    font-weight: 350;
                                    color: #00E0DB;
                                    margin-top: .21rem;

                                    span {
                                        font-size: 0.2rem;
                                        font-weight: 500;
                                    }
                                }

                                .box_1 {
                                    width: 4.25rem;
                                    height: 1rem;
                                    background: rgba(255, 255, 255, 0.05);
                                    border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                                    opacity: 1;

                                    .info_flex {
                                        display: flex;
                                        justify-content: space-between;
                                        // margin-top: .4rem;
                                        margin-left: .1rem;


                                        .info_t {
                                            flex: 1;
                                            font-size: 0.13rem;
                                            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                                            font-weight: 350;
                                            color: #FFFFFF;
                                            display: flex;
                                            flex-direction: column;
                                            // justify-content: space-between;

                                            div {
                                                padding: 0.08rem 0;

                                                span:nth-child(2) {
                                                    color: #FFFFFF;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .pie_box {
                    display: flex;
                    width: 9.5rem;
                    height: 3.81rem;
                    background: rgba(0, 223, 218, 0.04);
                    border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                    opacity: 1;
                    margin-top: .4rem;

                    .chart {
                        flex: 1;
                        margin-top: .49rem;

                        #pieInitChart {
                            width: 100%;
                            // height: 2.06rem;
                            height: 3rem;
                        }
                    }
                }
            }
        }
    }

    .info_flex {
        display: flex;
        justify-content: space-between;
        // margin-top: .4rem;
        margin-left: .2rem;

        .info_t {
            flex: 1;
            font-size: 0.18rem;
            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            flex-direction: column;
            // justify-content: space-between;

            div {
                padding: .15rem;

                span:nth-child(2) {
                    color: #FFFFFF;
                }
            }
        }
    }

    .quan {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // margin-top: .56rem;


        .cattle_ {
            display: flex;
            align-items: center;
            font-size: 0.2rem;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: bold;
            color: #00E0DB;

            span:nth-child(1) {
                display: inline-block;
                width: 0.11rem;
                height: 0.2rem;
                background: #00E0DB;
                border-radius: 0rem 0rem 0rem 0rem;
                opacity: 1;
                margin-right: .15rem;
            }
        }
    }

    .switchImg {
        margin-top: .25rem;
        display: flex;
        justify-content: center;

        span {
            display: flex;
            justify-content: center;
            align-items: center;
            width: .23rem;
            height: .23rem;
            border-radius: 50%;
            // border: 1px solid #FFFFFF;
            border: 1px solid rgba(255, 255, 255, 0.2);
            margin-left: .15rem;
            // color: #FFFFFF;
            color: rgba(255, 255, 255, 0.2);
            cursor: pointer;
        }
    }


    .line_info {
        display: flex;
        justify-content: space-around;

        .line {
            display: flex;
            flex-direction: column;

            justify-content: space-around;

            .info {
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 0.5rem 0;

                img {
                    width: .74rem;
                    height: .61rem;
                }

                .text {
                    display: flex;
                    flex-direction: column;
                    margin-left: .43rem;

                    span {
                        font-size: 0.28rem;
                        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                        font-weight: 500;
                        color: #23FFF9;
                    }

                    span:nth-child(2) {
                        font-size: 0.18rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                        padding-top: .2rem;
                    }
                }
            }
        }
    }

    .active {
        color: #000000 !important;
        background-color: #23fff9 !important;

        &::after {
            position: absolute;
            // left: 1.9rem;
            left: 2.15rem;
            top: 0;
            content: "";
            display: block;
            // border: .28rem solid transparent;
            // border-right: 0.28rem solid #23fff9 !important;
            // border-top: 0.28rem solid #23fff9 !important;
            border-width: 0.28rem 0.16rem;
            border-style: solid;
            border-color: #23fff9 #23fff9 transparent transparent;
        }
    }

    .active1 {
        background-color: #23fff9 !important;
        color: #000000 !important;
    }

    .round {
        width: .01rem !important;
        height: 0.4rem !important;
        background: none !important;
        box-shadow: none !important;
        border: none !important;
        // margin: 0 .1rem !important;
        margin-top: .1rem;
    }
}
</style>